import React from 'react'
import { Container, Row, Col } from '../../../../components/ui/wrapper'
import ProgressCirle from '../../../../components/ui/progress-circle/layout-one'
import { SectionWrap, FeatureListProgressWrap, ProgressCircleWrap, FeatureList } from './style'
import SectionTitle from '../../../../components/ui/section-title'
import { useStaticQuery, graphql } from "gatsby"

const ProgressCircleSection = () => {
    const TeamSkillSetQueryData = useStaticQuery(graphql`
    query TeamSkillSetDataQuery{
        skills(id: {eq: "team-skill"}) {
            title
            desc
            circleColLeft {
              title
              value
              desc {
                one
                two
              }
            }
            circleColMd {
              title
              value
              desc {
                one
                two
                three
              }
            }
            circleColRight {
              title
              value
              desc {
                one
                two
                three
              }
            }
          }
    }
`);

    const circleLeftData = TeamSkillSetQueryData.skills.circleColLeft;
    const circleMdData = TeamSkillSetQueryData.skills.circleColMd;
    const circleRightData = TeamSkillSetQueryData.skills.circleColRight;
    const {desc, title} = TeamSkillSetQueryData.skills;

    return (
        <SectionWrap>
            <Container>
                <Row>
                    <Col lg={12}>
                        <SectionTitle
                            title={title}
                        />
                    </Col>
                </Row><br></br>
                <p style={{textAlign: "center"}}>{desc}</p>
                
                <Row>
                     <Col lg={4}>
                         {circleLeftData && circleLeftData.map((skill, i) => (
                        <FeatureListProgressWrap >
                            <ProgressCircleWrap>
                                <ProgressCirle value={skill.value} />
                            </ProgressCircleWrap>
                            <FeatureList>
                                <h6>{skill.title}</h6>
                                <ul>
                                    <li>{skill.desc.one}</li>
                                    <li>{skill.desc.two}</li>
                                </ul>
                            </FeatureList>
                        </FeatureListProgressWrap>
                          ))}
                     </Col>
                     <Col lg={4}>
                         {circleMdData && circleMdData.map((skill, i) => (
                        <FeatureListProgressWrap>
                            <ProgressCircleWrap>
                                <ProgressCirle value={skill.value} varient="secondary"/>
                            </ProgressCircleWrap>
                            <FeatureList>
                                <h6>{skill.title}</h6>
                                <ul>
                                    <li>{skill.desc.one}</li>
                                    <li>{skill.desc.two}</li>
                                    <li>{skill.desc.three}</li>
                                </ul>
                            </FeatureList>
                        </FeatureListProgressWrap>
                          ))}
                     </Col>
                     <Col lg={4}>
                         {circleRightData && circleRightData.map((skill, i) => (
                        <FeatureListProgressWrap>
                            <ProgressCircleWrap>
                                <ProgressCirle value={skill.value} />
                            </ProgressCircleWrap>
                            <FeatureList>
                                <h6>{skill.title}</h6>
                                <ul>
                                    <li>{skill.desc.one}</li>
                                    <li>{skill.desc.two}</li>
                                    <li>{skill.desc.three}</li>
                                </ul>
                            </FeatureList>
                        </FeatureListProgressWrap>
                          ))}
                     </Col>
                </Row>
                

            </Container>
        </SectionWrap>
    )
}

export default ProgressCircleSection
